import { render, staticRenderFns } from "./StayTile.vue?vue&type=template&id=3ebe6d57&"
import script from "./StayTile.vue?vue&type=script&lang=js&"
export * from "./StayTile.vue?vue&type=script&lang=js&"
import style0 from "./StayTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3ebe6d57', component.options)
    } else {
      api.reload('3ebe6d57', component.options)
    }
    module.hot.accept("./StayTile.vue?vue&type=template&id=3ebe6d57&", function () {
      api.rerender('3ebe6d57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StayTile.vue"
export default component.exports